import React, { useEffect, useState } from "react";
import config from "../../config";
import { authFetch } from "../../utils/Security/authFetch";

interface Entity {
  id?: number;
  name?: string;
  type?: string;
}

interface MasterCrudProps {
  entityType:
    | "categories"
    | "changephase"
    | "closurecode"
    | "closurecodeproblem"
    | "closurecodetask"
    | "Errors"
    | "tasktype"
    | "ChangeTemplates";
    
}

const MasterCrud: React.FC<MasterCrudProps> = ({ entityType }) => {

  const [data, setData] = useState<Entity[]>([]);
  const [newItem, setNewItem] = useState<Entity>(
    entityType === "Errors" ? { type: "" } : { name: "" }
  );

  // Fetch
  const fetchData = async () => {
    try {

      const res = await authFetch(
        `${config.apiBaseUrl}/api/master/${entityType}`
      );

      if(!res.ok){
        throw new Error("Fetch failed");
      }

      const data = await res.json();

      setData(data);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setNewItem(entityType === "Errors" ? { type: "" } : { name: "" });
    fetchData();
  }, [entityType]);

  // Add or update
  const handleSave = async (item: Entity) => {

    try {

      const id = item.id;

      const payload =
        entityType === "Errors"
          ? { type: item.type }
          : { name: item.name };

      const url = id
        ? `${config.apiBaseUrl}/api/master/${entityType}/${id}`
        : `${config.apiBaseUrl}/api/master/${entityType}`;

      const method = id ? "PUT" : "POST";

      await authFetch(url,{
        method:method,
        headers:{
          "Content-Type":"application/json"
        },
        body:JSON.stringify(payload)
      });

      setNewItem(
        entityType === "Errors"
          ? { type: "" }
          : { name: "" }
      );

      fetchData();

    } catch (err) {
      console.error(err);
    }
  };

  // Delete
  const handleDelete = async (id: number) => {

    try {

      await authFetch(
        `${config.apiBaseUrl}/api/master/${entityType}/${id}`,
        {
          method:"DELETE"
        }
      );

      fetchData();

    } catch (err) {
      console.error(err);
    }
  };

  const getValue = (item: Entity) => {
    return entityType === "Errors"
      ? item.type || ""
      : item.name || "";
  };

  const setValue = (item: Entity, value: string) => {

    return entityType === "Errors"
      ? { ...item, type: value }
      : { ...item, name: value };

  };

  return (

    <div className="p-4 max-w-md mx-auto">

      <h2 className="text-xl font-bold mb-4">
        {entityType.toUpperCase()}
      </h2>

      <div className="flex mb-4">

        <input
          type="text"
          placeholder={`Enter ${
            entityType === "Errors"
              ? "type"
              : "name"
          }`}
          value={
            entityType === "Errors"
              ? newItem.type || ""
              : newItem.name || ""
          }
          onChange={(e)=>
            setNewItem(
              entityType === "Errors"
                ? {...newItem,type:e.target.value}
                : {...newItem,name:e.target.value}
            )
          }
          className="border px-2 py-1 flex-1 mr-2"
        />

        <button
          onClick={()=>handleSave(newItem)}
          className="bg-blue-500 text-white px-4 py-1 rounded"
        >
          Add
        </button>

      </div>

      <ul>

        {data.map((item)=>(

          <li
            key={item.id}
            className="flex justify-between mb-2"
          >

            <input
              type="text"
              value={getValue(item)}
              onChange={(e)=>
                setData(
                  data.map((d)=>
                    d.id === item.id
                      ? setValue(d,e.target.value)
                      : d
                  )
                )
              }
              className="border px-2 py-1 flex-1 mr-2"
            />

            <button
              onClick={()=>handleSave(item)}
              className="bg-green-500 text-white px-2 py-1 rounded mr-2"
            >
              Save
            </button>

            <button
              onClick={()=>handleDelete(item.id!)}
              className="bg-red-500 text-white px-2 py-1 rounded"
            >
              Delete
            </button>

          </li>

        ))}

      </ul>

    </div>

  );

};

export default MasterCrud;